import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { trackMetaEvent } from "./lib/meta";
import Home from "./components/Home";
import ThankYou from "./components/ThankYou";
import GalleryPage from "./components/GalleryPage";
import BookNowPage from "./components/BookNowPage";
import BookNowCoatingPage from "./components/BookNowCoatingPage";
import BookFriendsFamilyPage from "./components/BookFriendsFamilyPage";
import LocationServicePage from "./components/LocationServicePage";
import ServiceAreasPage from "./components/ServiceAreasPage";
import AdminDashboard from "./components/AdminDashboard";
import { SaleProvider } from "./context/SaleContext";
import SaleBanner from "./components/SaleBanner";

// Instantly snap to top on every route change + fire Meta PageView
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    // Fire Meta PageView on every navigation (both Pixel and CAPI, dedup'd)
    trackMetaEvent({ eventName: 'PageView' });
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <SaleProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SaleBanner />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/book-now" element={<BookNowPage />} />
            <Route path="/book-now-coating" element={<BookNowCoatingPage />} />
            <Route path="/book-friends-family" element={<BookFriendsFamilyPage />} />
            <Route path="/service-areas" element={<ServiceAreasPage />} />
            <Route path="/locations/:city/:service" element={<LocationServicePage />} />
            <Route path="/thank-you" element={<ThankYou />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
      </SaleProvider>
    </div>
  );
}

export default App;